import { type VariationComponent, ZoneColumnCombo } from "~types/types";
import {
    type IntegrityStatus,
    checkItemIntegrity,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    alternateItems = [],
    items = [],
    renderingLocation = ZoneColumnCombo.unsupported,
}: VariationComponent): IntegrityStatus {
    const messages: IntegrityStatus = [];
    const itemsLength = items?.length || 0;
    const totalItemsLength = itemsLength + (alternateItems?.length || 0);

    if (!items || !items?.length) {
        messages.push("This module has no items, please add items.");
    }

    if (
        itemsLength < 3 &&
        renderingLocation === ZoneColumnCombo.leftContentWell
    ) {
        messages.push(
            "This module requires 3 stories minimum when curated into a leftContentWell."
        );
    }

    if (
        totalItemsLength < 4 &&
        renderingLocation === ZoneColumnCombo.fullWidthContentWell
    ) {
        messages.push(
            "This module requires 4 stories minimum when curated into a fullWidthContentWell."
        );
    }

    const primaryStoryErrors = checkItemIntegrity(items[0], ["headline"]).map(
        (message: string) => `First Story: ${message}`
    );

    messages.concat(primaryStoryErrors);

    const secondaryStories = items.slice(1);

    const secondaryStoriesErrors = checkItemArrayIntegrity(secondaryStories, [
        "headline",
    ]).map((message: string) => `Secondary Stories: ${message}`);

    messages.concat(secondaryStoriesErrors);

    return messages;
}
